import { AssessmentUpdateDto, ClientIdentificationDto } from 'types/clientIdentification';

/**
 * The answers as stored, with the given ones changed. Every popup sends them all, so a popup that edits one answer
 * never clears the others.
 */
export function assessmentUpdate(
    assessment: ClientIdentificationDto,
    changes: Partial<AssessmentUpdateDto> = {}
): AssessmentUpdateDto {
    return {
        tierCode: assessment.tierCode,
        clientOwnerAnswer: assessment.clientOwnerAnswer,
        pepAnswer: assessment.pepAnswer,
        pepDetails: assessment.pepDetails,
        sourceOfFundsCodes: assessment.sourceOfFundsCodes,
        sourceOfFundsNote: assessment.sourceOfFundsNote,
        relevantBanks: assessment.relevantBanks,
        ...changes,
    };
}
